import React from "react";
import { observer } from "mobx-react";
import { TenantWidgetAccessCreateStore } from "../../store";
import { TenantWidgetAccessCreateForm } from "./TenantWidgetAccessCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type TenantWidgetAccessCreateProps = {
  tenantWidgetAccessCreateStore: TenantWidgetAccessCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const TenantWidgetAccessCreate: React.FC<TenantWidgetAccessCreateProps> =
  observer(
    ({ tenantWidgetAccessCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={tenantWidgetAccessCreateStore.isSaving} />
          <TenantWidgetAccessCreateForm
            tenantWidgetAccessCreateStore={tenantWidgetAccessCreateStore}
            tenantError={tenantWidgetAccessCreateStore.errors.tenant?.message}
            onTenantChange={(value) => {
              tenantWidgetAccessCreateStore.setTenantValue(value);
            }}
            tenantSelectedValue={
              tenantWidgetAccessCreateStore.entityValues.showTenant
            }
            onTenantSelected={(value) => {
              tenantWidgetAccessCreateStore.setSelectedTenant(value);
            }}
            tenantOptions={tenantWidgetAccessCreateStore.getTenantOptions()}
            widgetError={tenantWidgetAccessCreateStore.errors.widget?.message}
            onWidgetChange={(value) => {
              tenantWidgetAccessCreateStore.setWidgetValue(value);
            }}
            widgetSelectedValue={
              tenantWidgetAccessCreateStore.entityValues.showWidget
            }
            onWidgetSelected={(value) => {
              tenantWidgetAccessCreateStore.setSelectedWidget(value);
            }}
            widgetOptions={tenantWidgetAccessCreateStore.getWidgetOptions()}
            enabledError={tenantWidgetAccessCreateStore.errors.enabled?.message}
            onEnabledChange={(value: boolean) => {
              tenantWidgetAccessCreateStore.setEnabledValue(value);
            }}
            enabled={tenantWidgetAccessCreateStore.entityValues.enabled}
            configOverrideError={
              tenantWidgetAccessCreateStore.errors.configOverride?.message
            }
            onConfigOverrideChange={(value: string) => {
              tenantWidgetAccessCreateStore.setConfigOverrideValue(value);
            }}
            configOverride={
              tenantWidgetAccessCreateStore.entityValues.configOverride
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={tenantWidgetAccessCreateStore.isProcessing}
            onSave={() =>
              tenantWidgetAccessCreateStore.saveNewTenantWidgetAccess()
            }
            onCancel={() =>
              tenantWidgetAccessCreateStore.cancelNewTenantWidgetAccess()
            }
          />
          <ErrorDialog
            open={tenantWidgetAccessCreateStore.errorDialogOpened}
            title={tenantWidgetAccessCreateStore.errorTitle}
            description={tenantWidgetAccessCreateStore.errorDescription}
            onClose={() => tenantWidgetAccessCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
